/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable guard-for-in */
/* eslint-disable no-console */
import SelectorEngine from '../../../utils/dom/selector-engine';
import { Events } from '../../../utils/dom/html-events';
import EventHandler from '../../../utils/dom/event-handler';
import Modal from '../../../components/Modal';
import { ClassNames } from '../../../utils/dom/css-classes';
import Request, { ApiMode } from '../../../utils/request';
import FormGenerator, { FormTypes } from '../../../components/FormGenerator';
import { startLoadingAnimation, stopLoadingAnimation } from '../../../utils/dom/loading';

const SELECTOR_WRAPPER = '.p-add-work-card';
const SELECTOR_MODAL = '#js-add-work-card-modal';

const SELECTOR_STEP = '.p-add-work-card-step';
const SELECTOR_QUESTION = '.p-add-work-card-questions';

const ADD_WORK_CARD_SUCCESS = '.p-add-work-card-step-success';
const ADD_WORK_CARD_SUCCESS_BUTTON = '.p-add-work-card-step-success--button';

const SELECTOR_EXIT_BUTTON = '.js-exit-add-work-card';
const SELECTOR_EXIT_CONFIRM_MODAL = '.js-exit-add-work-card-confirm';
const SELECTOR_EXIT_CONFIRM_YES = '.js-exit-add-work-card-confirm-yes';
const SELECTOR_EXIT_CONFIRM_NO = '.js-exit-add-work-card-confirm-no';

const SELECTOR_CONFIRMATION_CONFIRM_BUTTON = '.p-add-work-card-confirmation-confirm';

const IS_LOCAL = false;

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';

const KEY_OBJECT = 'fieldName';
const VALUE_OBJECT = 'value';

class AddWorkCard {
	constructor() {
		this._wrapper = SelectorEngine.findOne(SELECTOR_WRAPPER);
		if (!this._wrapper) {
			return;
		}
		this.init();
	}

	get stepsData() {
		return this._stepsData;
	}

	set stepsData(_stepsData) {
		this._stepsData = _stepsData;
		if (_stepsData?.length > 0) {
			this.initiateFormGenerator(_stepsData);
		}
	}

	init() {
		this.modalElement = SelectorEngine.findOne(SELECTOR_MODAL, this._wrapper);
		this.modal = new Modal(this.modalElement, { backdrop: 'static' });
		this.modal.show();
		this.fetchSteps();

		this.step = SelectorEngine.findOne(SELECTOR_STEP, this._wrapper);
		this.workCardquestions = SelectorEngine.findOne(SELECTOR_QUESTION, this.step);
		this.AddWorkCardSuccess = SelectorEngine.findOne(ADD_WORK_CARD_SUCCESS, this._wrapper);
		this.AddWorkCardSuccessButton = SelectorEngine.findOne(ADD_WORK_CARD_SUCCESS_BUTTON, this.AddWorkCardSuccess);

		this.exitButton = SelectorEngine.findOne(SELECTOR_EXIT_BUTTON, this._wrapper);
		const exitConfirmModalHtml = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_MODAL, this._wrapper);
		this.exitConfirmModal = new Modal(exitConfirmModalHtml, { backdrop: 'static' });

		this.exitConfirmYes = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_YES, this._wrapper);
		this.exitConfirmNo = SelectorEngine.findOne(SELECTOR_EXIT_CONFIRM_NO, this._wrapper);

		this.AddWorkCardConfirmButton = SelectorEngine.findOne(SELECTOR_CONFIRMATION_CONFIRM_BUTTON, this._wrapper);

		EventHandler.on(this.AddWorkCardSuccessButton, CLICK_EVENT, () => {
			this.modal.hide();
		});

		EventHandler.on(this.AddWorkCardConfirmButton, CLICK_EVENT, () => {
			this.AddWorkCardConfirmButton.disabled = true;
			this.saveAddWorkCardSteps(this.answerList);
		});

		this.initEventHandlers();
	}

	initEventHandlers() {
		EventHandler.on(this.exitButton, Events.Click, () => {
			this.exitConfirmModal.show();
		});
		EventHandler.on(this.exitConfirmYes, Events.Click, () => {
			this.handleModalExit();
		});
		EventHandler.on(this.exitConfirmNo, Events.Click, () => {
			this.exitConfirmModal.hide();
		});
	}

	async fetchSteps() {
		try {
			// TODO CSA: this endpoint has not been confirmed yet
			const url = '/api/officials/createworksteps';
			const response = await Request.get(
				url,
				{},
				{
					local: IS_LOCAL,
					req: {
						apiMode: ApiMode.LtaError
					}
				}
			);
			const { Steps, error } = response;
			if (Steps) {
				this.stepsData = Steps;
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			console.log('error', error);

			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	showSuccessPage() {
		this.step.classList.add(HIDDEN_CLASS);
		this.AddWorkCardSuccess.classList.remove(HIDDEN_CLASS);
	}

	initiateFormGenerator(stepsData) {
		this.step.classList.remove(ClassNames.Hidden);

		this.formGenerator = new FormGenerator(this.workCardquestions, {
			questions: stepsData,
			totalSteps: 2,
			hasSeparator: false,
			formType: FormTypes.StepForm,
			themeColor: 'color-lta-blue',
			// radioAnswerField: 'id',
			isBackButtonEnabled: true
		});

		this.formGenerator.onChange((answers) => {
			this.step.classList.add(HIDDEN_CLASS);
			this.prepareRequestObject(answers);
			this.saveAddWorkCardSteps(this.answerList);
		});
		EventHandler.on(this.AddWorkCardConfirmButton, Events.Click, () => {
			const isFormValid = this.formGenerator.formValidation();
			if (isFormValid) {
				console.log('Answers :', this.answerList);
				this.saveAddWorkCardSteps(this.answerList);
			}
		});
	}

	prepareRequestObject(stepsAnswers) {
		this.answerList = {};
		for (const stepKey in stepsAnswers) {
			const stepAnswersObjects = stepsAnswers[stepKey];
			for (const questionKey in stepAnswersObjects) {
				const answerObject = stepAnswersObjects[questionKey];
				const formatObject = {};
				formatObject[answerObject[KEY_OBJECT]] = answerObject[VALUE_OBJECT];
				this.answerList = {
					...this.answerList,
					...formatObject
				};
			}
		}
	}

	async saveAddWorkCardSteps(requestObject) {
		const payload = {
			Id: '',
			NumberOfDays: requestObject.NumberOfDays,
			NumberOfEntries: requestObject.NumberOfEntries,
			NumberOfEvents: requestObject.NumberOfEvents,
			RefereeName: requestObject.tournament.tournamentRefreeName,
			TournamentCode: requestObject.tournament.tournamentCode,
			TournamentEndDate: requestObject.tournament.tournamentEndDate,
			TournamentGrade: requestObject.tournament.tournamentGrade,
			TournamentName: requestObject.tournament.tournamentName,
			TournamentStartDate: requestObject.tournament.tournamentStartDate,
			TournamentVenue: requestObject.tournament.tournamentVenue,
			Open: requestObject.Open,
			Mini: requestObject.Mini,
			Junior: requestObject.Junior,
			Senior: requestObject.Senior,
			ContactRole: requestObject.ContactRole
		};
		try {
			const url = '/api/officials/createeditworkcard';
			startLoadingAnimation();
			const response = await Request.post(url, payload, {
				local: IS_LOCAL,
				req: {
					apiMode: ApiMode.LtaError
				}
			});
			const { Success, success, error } = response;
			stopLoadingAnimation();
			if (Success || success) {
				this.showSuccessPage();
			}

			if (!!error?.hasError) {
				throw error;
			}
		} catch (error) {
			stopLoadingAnimation();
			if (error.hasError) {
				console.log('Error :', error);
			}
		}
	}

	handleModalExit() {
		// Go back to the page that launched the modal
		history.back();
	}
}

const globalAddWorkCard = new AddWorkCard();
export default globalAddWorkCard;
